// deps
import React from "react";

// internal deps
import { CodGroup } from "@swiggy-private/payment-ui";

// interfaces
import { PaymentGroupHandlerProps } from "@payment-client/components/show-payments/components/payment-group-handler/interfaces";

// hooks
import { usePaymentActions } from "@payment-client/components/show-payments/components/payment-group-handler/hooks/UsePaymentActions";

// contexts
import useCodHandler from "../hooks/useCodHandler";

// constants
import { SCREEN_NAME } from "@payment-client/analytics/constants";

// types
type CODGroupHandlerProps = PaymentGroupHandlerProps;

export function CODGroupHandler(props: CODGroupHandlerProps): React.ReactElement | null {
    const { onSelect, onPay, paymentGroup, ...otherProps } = props;
    const { codSpecificActions } = useCodHandler(SCREEN_NAME.PAYMENT);

    const paymentActions = {
        ...usePaymentActions({ onSelect, onPay }),
        ...codSpecificActions,
    };

    return <CodGroup paymentActions={paymentActions} paymentData={paymentGroup} {...otherProps} />;
}
